import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleCalendarElement } from '@libs/store';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TimeRangeFormatPipe } from '../../time-range-format';
import { AppointmentStatusChipComponent } from '../appointment-status-chip';

@Component({
  selector: 'lib-schedule-calendar-item-tooltip',
  templateUrl: './schedule-calendar-item-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TimeRangeFormatPipe, AppointmentStatusChipComponent, SvgIconComponent],
})
export class ScheduleCalendarItemTooltipComponent {
  @Input({ required: true }) public vm!: ScheduleCalendarElement;
}
